import React, { useEffect, useRef, useState } from "react";
import { Button, checkAccess } from "../../../Util/common";
import { KendoLoader } from "../../../Kendo/kendo_loader";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import { KendoMultiSelect } from "../../../Kendo/kendo_multiselect";

export const RentalServiceDetails = () => {
  const [WelcomeToList, setWelcomeToList] = useState([]);
  const [editVisible, setEditVisible] = useState(false);
  const [error, setError] = useState({});
  const [DisplayedIn, setDisplayedIn] = useState("");
  const [Title, setTitle] = useState("");
  const [ButtonName, setButtonName] = useState("");
  const [URL, setURL] = useState("");
  const [Description, setDescription] = useState("");
  const [Category, setCategory] = useState("");

  const [Flag, setFlag] = useState(false);

  const modalRef = useRef(null);

  const clearForm = () => {
    setEditVisible(false);
  };
  const onSubmit = async (e) => {};
  const handleEditClick = async (e) => {
    const modal = new bootstrap.Modal(document.getElementById("add_culture"));
    modal.show();
  };
  const dummyData = [
    {
      WelcomeToId: 1,
      Category: "Broucher",

      Description:
        "Meridian Convention Center is a premier event venue located in the heart of the city, offering exceptional services for events of all kinds.",
      Images:
        "https://qaph3.meridianconvention.com/PageImages/Banner/2024052400241120230908045320valencia1-min-min.jpg",
    },
    {
      WelcomeToId: 2,
      Category: "Online Availability",

      Description:
        "Barcelona is a vibrant and cultural destination, known for its beautiful architecture and rich history.",
      Images:
        "https://qaph3.meridianconvention.com/PageImages/Banner/2024052023201220220525014015MSH_MariaSollecito-MKS_1210%20-%20edited%202-min-min.jpg",
    },
    {
      WelcomeToId: 3,
      Category: "Delivery & Setup",

      Description:
        "At Meridian, we provide professional event management services to help you create the perfect corporate events, from conferences to banquets.",
      Images:
        "https://qaph3.meridianconvention.com/PageImages/Banner/2024052023214320230518203202WhatsApp%20Image%202022-12-30%20at%201.36.51%20PM-min-min.jpeg",
    },
    {
      WelcomeToId: 4,
      DisplayedIn: "Barcelona",
      Title: "Our Services",

      Description:
        "Explore the variety of services we offer for all types of events, including weddings, conferences, and corporate gatherings.",
      Images:
        "https://qaph3.meridianconvention.com/PageImages/Banner/2024052023215220230219161819WhatsApp%20Image%202023-02-19%20at%204.02.05%20PM-min-min.jpeg",
    },
  ];

  const DisplayedinList = [
    { id: "01", text: "Broucher" },
    { id: "02", text: "Online Availability" },
    { id: "03", text: "Delivery & Setup" },
  ];

  const DisplayedInChangeF = (e) => {
    let numString = e;
    let numArray = numString.split(",");
    if (numArray[0] == "0" || !numArray.includes("0")) {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num !== "0") : numArray;
    } else {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num == "0") : numArray;
    }

    e = numArray.join(",");
    if (e == "") {
      setDisplayedIn("");
    } else {
      setDisplayedIn(e);
    }
  };

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Rental Service Details</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="index.html">Configuration</a>
              </li>
              <li className="breadcrumb-item active">Rental Service Details</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              {/* {checkAccess("APPCONFIGCREATE") && ( */}
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_WelcomeSection"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
              {/* )} */}
            </div>

            <div>
              {!WelcomeToList ? (
                <div className="row">
                  {" "}
                  <div className="col-12">
                    <KendoLoader />
                  </div>
                </div>
              ) : (
                <KendoGrid
                  name={"welcomeTo-config"}
                  data={dummyData}
                  schema={{}}
                  columns={[
                    {
                      field: "WelcomeToId",
                      filterable: false,
                      hidden: true,
                    },
                    {
                      field: "Category",
                      title: "Category",
                    },

                    {
                      field: "Description",
                      title: "Description",
                    },
                    {
                      field: "Images",
                      title: "Images",
                      // Template for displaying images with fixed size
                      template: (dataItem) =>
                        `<img src="${dataItem.Images}"  width="40px" height="40px" />`,
                    },

                    // {
                    //   template: function (e) {
                    //     if (e.ImageName) {
                    //       return `<img src="${e.ImageName}" width="40px" height: "40px" />`;
                    //     }
                    //     return "";
                    //   },

                    //   title: "Image",
                    // },
                  ]}
                  showOptions={true}
                  showEdit={true}
                  showDelete={true}
                  onEditClick={(e) => handleEditClick(e)}
                  // onDeleteClick={(e) => {
                  //   handleDeleteClick(e);
                  // }}
                  disableExportExcel={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add WelcomeSection Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_WelcomeSection"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Select Category <span className="text-danger">*</span>
                    </label>
                    <KendoMultiSelect
                      name="type"
                      data={DisplayedinList}
                      value={Category}
                      dataTextField={"text"}
                      dataValueField={"id"}
                      placeholder={"Select Category..."}
                      tagmode={"multiple"}
                      required={true}
                      refreshWhen={Flag}
                      onChange={(e) => DisplayedInChangeF(e)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      maxLength={200}
                      className="form-control field"
                      name="Description"
                      value={Description}
                      placeholder="Description"
                      data-required="true"
                      onChange={(e) => {
                        setDescription(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Upload Image <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      name="File"
                      // onChange={handleFileChange}
                    />
                  </div>
                  {/* <div className="col-md-2 mb-3">
                <button
      type="submit"
      className="btn btn-primary mt-2"
      title="Add Function"
    >
      <i className="las la-plus-circle"></i>
    </button> 
                </div> */}
                </div>

                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    id="ballroom-cul-cancel"
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button name={"Save"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add WelcomeSection Modal --> */}
    </>
  );
};
